<template>
	<div class="lb">

		<div ref="Tmain2" class="tmain2" :style="{ width: '440px', height: '240px' }"></div>
	</div>
</template>

<script>
export default {
	name: 'template.leftBottom',
	data() {
		return {
			chartDom: "",
			myChart: "",
			option: "",
			TmyChart: "",
			Toption: "",
			titleName4: "",
		}
	},

	beforeDestroy() {
		clearInterval(this.timer);
	},
	methods: {
		TdrawLine() {
			var echarts = require('echarts');
			var TmyChart = echarts.init(this.$refs.Tmain2);
			let myDate = ['福建', '上海', '北京', '山东', '河北', '安徽', '四川', '陕西', '湖南'];

			let numA = [8.0, 7.7, 7.0, 6.8, 6.0, 5.8, 5.6, 5.0, 4.8];
			let numB = [0.14, 0.14, 0.14, 0.14, 0.14, 0.14, 0.14, 0.14, 0.14];
			var Toption = {
				title: {

					subtext: '万元',
					subtextStyle: {
						color: "#B0B5BB",

					},
					top: '8',
					left: '-6'

				},
				tooltip: {
					trigger: 'axis'
				},
				legend: {
					show: false

				},
				grid: {
					left: '2',
					right: '6%',
					bottom: '0',
					top: '28%',
					containLabel: true
				},
				xAxis: {
					type: 'category',
					boundaryGap: true,
					data: myDate,
					axisLabel: {
						// interval:1,
						textStyle: {
							color: '#bdc2cb' // 这里将 x 轴文本颜色设为红色
						}
					},
					axisLine: {
						lineStyle: { // X 轴颜色配置
							color: '#4792e9'
						}
					},
					axisTick: {
						show: false
					},

				},
				yAxis: {
					type: 'value',
					// name: "万元",
					// nameTextStyle: {
					// 	color: "#B0B5BB",
					// 	nameLocation: "start",
					// 	padding: [0, 0, 0, -20]
					// },
					splitNumber: 4,
					axisLabel: {
						textStyle: {
							color: '#bdc2cb' // 这里将 x 轴文本颜色设为红色
						}
					},
					axisLine: {
						show: false
					},
					splitLine: {
						show: true,
						lineStyle: {
							type: 'dashed',
							color: "rgba(231,241,251,.2)"
						}
					}
				},
				series: [
					{
						// name: '万元',

						type: 'bar',
						smooth: true,
						stack: 'Total',
						itemStyle: {
							normal: {
								color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
									offset: 0,
									color: "#0b1f42" // 0% 处的颜色
								}, {
									offset: 0.5,
									color: "#0a4ba6" // 0% 处的颜色
								}, {
									offset: 1,
									color: "#0a72fc" // 100% 处的颜色
								}], false)
							}
						},
						symbolSize: 0,
						label: {
							show: true,
							position: 'top',
							textStyle: {
								//设置文本样式
								color: "#CBD8DE",
							}
						},
						data: numA,
						barGap: '5%', //柱子之间间距
						barCategoryGap: '68%',
					},
					{
						//文字下划线
						type: 'bar',
						stack: 'Total',
						itemStyle: {
							normal: {
								color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
									offset: 0,
									color: "#0a72fc" // 0% 处的颜色
								}, {
									offset: 1,
									color: "#0a72fc" // 100% 处的颜色
								}], false)
							}
						},
						data: numB,
						barGap: '5%', //柱子之间间距
						barCategoryGap: '68%',
					},
				]
			};
			Toption && TmyChart.setOption(Toption);
			setInterval(function () {
				TmyChart.clear();
				Toption && TmyChart.setOption(Toption);
			}, 5000)
		},
	},
	mounted() {
		this.$nextTick(() => {
			// this.drawLine(); //需要刷新的数据
			this.TdrawLine(); //需要刷新的数据
		});



	},
}
</script>

<style scoped>
.lb {
	width: 480px;
	height: 240px;
	padding: 10px 0;
	display: flex;
	position: relative;
	box-sizing: border-box;
}

.tmain2 {
	/* margin-left: 35px; */
	width: 480px;
	height: 240px;
	margin-left: 13px;
}
</style>